import React, { useState } from "react";
import ReactDOM from "react-dom";

const AddCategoryModal = ({ isOpen, onClose, onAdd }) => {
    if (!isOpen) return null; // Don't render the modal if it's not open

    const [categoryName, setCategoryName] = useState("");
    const [display, setDisplay] = useState(true);

    const handleSave = () => {
        if (!categoryName.trim()) {
            alert("Category name is required.");
            return;
        }

        onAdd({ categoryName, display });
        onClose(); // Close modal after saving
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Add New Category</h3>
                    <button className="close-button" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    <div className="form-group">
                        <label>Category Name</label>
                        <input
                            type="text"
                            className="filterInput"
                            placeholder="Category Name"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Display?</label>
                        <input
                            type="checkbox"
                            checked={display}
                            onChange={(e) => setDisplay(e.target.checked)}
                        />
                    </div>

                    <div className="modal-actions">
                        <button className="baseButton" onClick={handleSave}>
                            Save Category
                        </button>
                        <button className="baseButton secondary" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body // Renders the modal outside the regular DOM hierarchy
    );
};

export default AddCategoryModal;
